
import http from '@/base/api/public'
import querystring from 'querystring'

let apiUrl = require('@/../config/sysConfig')
// 検索
export const noticeDetailGet = (userCd, noticeCd) => {
    return http.requestGet(apiUrl.apiUrl_NoticeDetailSearch + '?userCd=' + userCd + '&noticeCd=' + noticeCd)
}

//文件查询
export const b_0002_getFile = (params) => {
    return http.requestQuickGetImage(apiUrl.apiUrl_FilesSearch + '?filePath=' + encodeURIComponent(params.filePath) + '&resizeCd=' + params.resizeCd)
}


// WEBPACK FOOTER //
// ./src/module/api/b_0002.js